import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import Button from "@ats/src/components/shared/Button";

const StyledSmallButton = styled(Button)((props) => {
  const t: any = props.theme;
  const styleType = props.styleType;
  return css`
    label: SmallButton;
    height: 40px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 2px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;

    ${t.mq["md"]} {
      height: 29px;
      font-size: 13px;
      font-weight: ${styleType === "primary" ? "500" : "450"};
    }
  `;
});

const SmallButton: React.FC<any> = (props) => (
  <StyledSmallButton {...props} size="small" />
);

export default SmallButton;
